import { ComponentProps, FC } from 'react';

import useClientState from '@/state/useClientState';

import ExtendedSearch from './v1/extendedSearch/ExtendedSearch';
import ExtendedSearchV2 from './v2/components/ExtendedSearch/ExtendedSearch';

const SearchBar: FC<ComponentProps<typeof ExtendedSearch> | ComponentProps<typeof ExtendedSearchV2>> = ({
  ...searchProps
}) => {
  const version = useClientState((state) => state.version);
  return (
    <>
      {version === 2 ? (
        <ExtendedSearchV2 {...(searchProps as ComponentProps<typeof ExtendedSearchV2>)} />
      ) : (
        <ExtendedSearch {...(searchProps as ComponentProps<typeof ExtendedSearch>)} />
      )}
    </>
  );
};
export default SearchBar;
